import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ProfileOwnerWatchButton } from '../../../../../../Button';
import { getDeviationType } from '../../../../../_helpers';
import { DeviationTypes } from '../../../../../../types/deviation';
import thumbPaywallStyles from './ThumbPaywall.scss';
var unlockHint = function (type, isMobile) {
    if (type === DeviationTypes.FILM) {
        return isMobile
            ? 'deviationview.overlay.premiumFolder.unlockHint.watch.mobile.video'
            : 'deviationview.overlay.premiumFolder.unlockHint.watch.video';
    }
    return isMobile
        ? 'deviationview.overlay.premiumFolder.unlockHint.watch.mobile'
        : 'deviationview.overlay.premiumFolder.unlockHint.watch';
};
var WatchersOnlyThumbPaywall = function (_a) {
    var deviation = _a.deviation, isSmall = _a.isSmall, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement("div", { className: classnames(thumbPaywallStyles['root'], isSmall && thumbPaywallStyles['small'], className) },
        React.createElement("div", { className: thumbPaywallStyles['label'] }, t(unlockHint(getDeviationType(deviation), isMobile))),
        deviation.author && (React.createElement(ProfileOwnerWatchButton, { fullWidth: false, className: thumbPaywallStyles['button'], user: deviation.author, onToggleWatchSuccess: function () {
                window.location.href = deviation.url;
            } }))));
};
WatchersOnlyThumbPaywall.displayName = 'WatchersOnlyThumbPaywall';
export default WatchersOnlyThumbPaywall;
//# sourceMappingURL=WatchersOnlyPaywall.js.map